var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "shortsPlatform"
  }, [_c("section", {
    staticClass: "shortsPlatform-banner",
    style: {
      background: `url(${_vm.imageUrl}) no-repeat center 0px`,
      backgroundSize: "cover"
    }
  }, [_c("Banner", {
    attrs: {
      imageUrl: _vm.imageUrl,
      title: _vm.bannerTitle,
      description: _vm.bannerText
    }
  })], 1), _c("Advantages", {
    attrs: {
      adslist: _vm.adsList
    }
  }), _c("Function"), _c("Cases", {
    attrs: {
      showCase: true,
      showTitle: false,
      casesText: _vm.caseText,
      source: "shortsPlatform"
    }
  }), _c("Appointment2")], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };